import { MUpdatePrice } from "../../../../../../server/routes/logUpdated/price/types";
import usePageLogUpdatedPriceContext from "./usePageLogUpdatedPriceContext";

const useList = (): { isLoading: boolean; items: MUpdatePrice[] } => {
  const { isLoading, items } = usePageLogUpdatedPriceContext();

  return { isLoading: isLoading.value, items: items.value };
};

export default useList;
